import React, { useEffect, useState } from "react";
import { Button, Input, Select } from "antd";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import { getApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
import dayjs from "dayjs";
const ProjectFilter = ({
  onOpen,
  onClose,
  setFilterData,
  clientId,
  customer = false,
  startDate, setStartDate,
  endDate, setEndDate,
  status, setStatus,
  projectType, setProjectType
}) => {
  // const [startDate, setStartDate] = useState("");
  // const [endDate, setEndDate] = useState("");
  // const [status, setStatus] = useState("");
  // const [projectType, setProjectType] = useState(null);
  const [projectTypeOptions, setProjectTypeOptions] = useState([]);
  const [isStartFocused, setIsStartFocused] = useState(false);
  const [isEndFocused, setIsEndFocused] = useState(false);

  const statusOptions = [
    "Project Created",
    "Project Setup Completed",
    "Form Submission in Progress",
    "Forms Submitted",
    "Report Requested",
    "Report Generated",
    "Audit Requested",
    "Audit in Progress",
    "Audit Completed",
  ];

  const handleSave = () => {
    const filter = {};

    if (startDate) filter.startDate = startDate;
    if (endDate) filter.endDate = endDate;
    if (projectType) filter.projectType = projectType;
    if (status) filter.status = status;

    setFilterData(filter);
    onClose();
  };

  const fetchProjectTypes = async () => {
    try {
      const response = await getApi({ apiUrl: API_URLS.GET_ALL_PROJECT_TYPES });
      if (response.success) {
        const types = response.data.data.map((item) => ({
          label: item.project_type,
          value: item._id,
        }));
        setProjectTypeOptions(types);
      }
    } catch (error) {
      console.error("Error fetching project types:", error);
    }
  };

  const handleCancel = () => {
    setStartDate("");
    setEndDate("");
    setProjectType(null);
    setStatus("");
    setIsStartFocused(false);
    setIsEndFocused(false);
    setFilterData("");
    onClose();
  };

  useEffect(() => {
    fetchProjectTypes();
  }, []);

  return (
    <div>
      <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
        <div>
          <h3 className=" text-xl">Filter</h3>
        </div>
        <div className="p-2 mt-6">
          <hr />
        </div>
        <div className="flex justify-between gap-10 mt-10">
          <div className="flex flex-col w-full">
            <Input
              type={isStartFocused ? "date" : "text"}
              value={ isStartFocused
                  ? startDate
                  : startDate
                    ? dayjs(startDate).format("DD-MM-YYYY")
                    : ""}
              onFocus={() => setIsStartFocused(true)}
              onBlur={(e) => {
                if (!e.target.value) setIsStartFocused(false);
              }}
              onChange={(e) => setStartDate(e.target.value)}
              placeholder="Start Date"
              style={{
                border: "1px solid #ebedf3",
                borderRadius: "10px",
                padding: "10px",
              }}
              className="text-base font-light h-14"
            />
          </div>

          <div className="flex flex-col w-full">
            <Input
              type={isEndFocused ? "date" : "text"}
              value={ isEndFocused
                  ? endDate
                  : endDate
                    ? dayjs(endDate).format("DD-MM-YYYY")
                    : ""}
              onFocus={() => setIsEndFocused(true)}
              onBlur={(e) => {
                if (!e.target.value) setIsEndFocused(false);
              }}
              onChange={(e) => setEndDate(e.target.value)}
              placeholder="End Date"
              style={{
                border: "1px solid #ebedf3",
                borderRadius: "10px",
                padding: "10px",
              }}
              className="text-base font-light h-14"
            />
          </div>
        </div>
        <div className="flex justify-between gap-10 mt-10">
          <div className="flex flex-col w-full">
            <Select
              value={projectType || undefined}
              onChange={setProjectType}
              placeholder="Project Type"
              className="text-lg font-light h-14"
              allowClear
            >
              {projectTypeOptions.map((type) => (
                <Select.Option key={type.value} value={type.label}>
                  {type.label}
                </Select.Option>
              ))}
            </Select>
          </div>

          <div className="flex flex-col w-full">
            <Select
              value={status || undefined}
              onChange={setStatus}
              placeholder="Status"
              className="text-lg font-light h-14"
              allowClear
            >
              {statusOptions.map((status, index) => (
                <Select.Option key={index} value={status}>
                  {status}
                </Select.Option>
              ))}
            </Select>
          </div>
        </div>

        <div className="px-20 mt-16 mb-4">
          <hr />
        </div>
        <div className="flex justify-center gap-4 py-6">
          <CustomButton
            buttonType="primary"
            variant="cancel"
            buttonText="Reset"
            className="text-sm px-6 py-2 rounded-lg"
            onClick={handleCancel}
          />
          <CustomButton
            buttonType="primary"
            variant="ok"
            buttonText="Save"
            className=" text-sm px-6 py-2 rounded-lg"
            onClick={handleSave}
          />
        </div>
      </DailogBox>
    </div>
  );
};

export default ProjectFilter;
